import { BookingStatus } from '@/services/types/booking/details';

import { ERentalType } from '../types';

export enum EBookingManagementEventName {
  RENTER_BOOKING_SELECTED = 'Renter Booking Selected',
  RENTER_BOOKING_VIEWED = 'Renter Booking Viewed',
  RENTER_BOOKING_ADDITIONAL_PROTECTION_STARTED = 'Additional Protection Started',
  RENTER_BOOKING_ADDITIONAL_PROTECTION_CONTINUED = 'Additional Protection Continued',
  RENTER_BOOKING_ADDITIONAL_PROTECTION_ADDED = 'Additional Protection Added',
  DRIVER_INVITED = 'Driver Invited',
  GUEST_INVITED = 'Guest Invited',
}

/**
 * INTERFACES
 */
export interface IBookingManagementEvent {
  bookingID: number;
  bookingDepartureDate: number;
  bookingReturnDate: number;
  isDelivery: boolean;
  bookingLocation: string;
  tripStatus: BookingStatus;
  rentalType: ERentalType;
  isCampground: boolean;
}

export interface IRenterBookingViewedEvent extends IBookingManagementEvent {
  totalDrivers: number;
  // null when the booking is waived / custom-insurance — the verified-driver
  // signal is Persona-only there (MP-6846 / MP-7076), so a real 0 would be
  // indistinguishable from a suppressed count. Downstream: exclude null rows
  // from verification-rate metrics rather than treating them as zero.
  totalVerifiedDrivers: number | null;
  insuranceCoverage: string | null;
  protectionType: string[] | null;
  totalAttendees: number;
  cancellationActor: string | null;
  changesForReview: string | null;
  // Whether the Ride car-rental cross-sell banner rendered on this view, so its
  // click-through rate can be measured against Ride Transition Selected.
  showedRideBanner: boolean;
}

export interface IRenterBookingAdditionalProtectionStarted {
  bookingID: number;
  protectionsSelected: string[] | null;
  protectionsCost: number;
  rentalType: ERentalType;
  isCampground: boolean;
}

export interface IRenterBookingAdditionalProtectionAdded
  extends IRenterBookingAdditionalProtectionStarted {
  paymentMethod: string | null;
}

export enum EBookingManagementEventSource {
  STATUS_CARD = 'status_card',
  GUESTS = 'guests',
}

export interface IDriverInvited {
  bookingID: number;
  source: EBookingManagementEventSource;
  totalDrivers: number;
  // null when the booking is waived / custom-insurance — see IRenterBookingViewedEvent.
  totalVerifiedDrivers: number | null;
  rentalType: ERentalType;
}

export interface IGuestInvited {
  bookingID: number;
  totalAttendees: number;
  source: EBookingManagementEventSource;
  rentalType: ERentalType;
  isCampground: boolean;
}
